import { type FC } from 'react'

import {
  ACTIONS,
  DESCRIPTIONS,
  ERROR_MESSAGES,
  MENU,
  SUCCESS_MESSAGES
} from '@/constants/common/message.constants'
import { createTruckClassImportJob } from '@/features/truck-class-import-jobs/api'

import { isOpenTruckClassImportModalAtom } from '../../-states'
import { CsvImportModal } from '../CsvImportModal/CsvImportModal'

type Props = {
  tenantKey: string
}

/**
 * 車格マスタインポートModal（取込は ADMIN + 選択中拠点の拠点マネージャー）
 */
export const TruckClassImportModal: FC<Props> = ({ tenantKey }) => {
  return (
    <CsvImportModal
      tenantKey={tenantKey}
      isOpenAtom={isOpenTruckClassImportModalAtom}
      modalTitle={MENU.TRUCK_CLASS_MASTER_IMPORT}
      draggerTitle={ACTIONS.UPLOAD_TRUCK_CLASS_DATA}
      draggerDescription={DESCRIPTIONS.UPLOAD_TRUCK_CLASS_DATA}
      createImportJob={(formValue, dcId) =>
        createTruckClassImportJob({ tenantKey, dto: { ...formValue, dcId } })
      }
      successMessage={SUCCESS_MESSAGES.STARTED_TRUCK_CLASS_IMPORT}
      errorMessage={ERROR_MESSAGES.FAILED_TO_START_TRUCK_CLASS_IMPORT}
      historyRoute="/$tenantKey/settings/truck-class-import-jobs"
    />
  )
}
